(function ($) {

  // Get any and all UTM parameters from URL if exist
  // and add to urlParams object
  urlParams = {};
  location.search.substr(1).split("&").forEach(function (pair) {
    if (pair === "") return;
    var parts = pair.split("=");
    urlParams[parts[0]] = parts[1] &&
      decodeURIComponent(parts[1].replace(/\+/g, " "));
  })

  // For each param in urlParms find matching input
  // and set value
  $.each(urlParams, function (key, value) {
    $('input[name="' + key + '"]').val(value)
  })

  // Pardot form submit
  $('.sf_submit').on('submit', function (e) {
    e.preventDefault()
    // Store a reference to this form
    var $this = $(this)
    // Declare empty array for field values
    var formData = []
    // Declare email field
    var formEmail = $this.find('input[name="email"]')
    // Declare submit btn
    var formSubmit = $this.find('.btn')

    // Get value of each field in form
    $('.sf_submit').each(function () {
      // Push each field value into formData array
      formData.push($(this).serializeArray())
    })

    // Disable input field
    formEmail.prop('disabled', true)
    // Show Loading in btn
    formSubmit.addClass('disabled').text('Loading...')

    //Submit the form passing all form field values
    $.ajax({
      url: '/wp-content/themes/konghq/inc/pardot.php',
      method: 'POST',
      data: formData[0],
      success: function (result) {
        // On success display thank you message
        if ($this.is('#request-demo-form')) {
          $this.replaceWith('<div class="form-thanks"><img src="https://cdn.jotfor.ms/img/check-icon.png"/><h1>Thank You!</h1><p>Your submission has been recieved.</p></div>')
        } else {
          $this.replaceWith('<p>' + result + '</p>')
        }
        // Remove sticky class and set cookie for 90 days after 2 seconds
        setTimeout(function () {
          $('.newsletter-container').removeClass('sticky');
          $.cookie('nl-popup', 'true', { expires: 90, path: '/' })
        }, 2000)
      },
      error: function (error) {
        // If Error display error message
        $('.sf_submit').replaceWith('<p>There appears to be an error, please try again later.</p>')
        console.log('error', error);
      }
    })

  })

  // Hide cookie policy agreement
  $('#accept-cookies').on('click', function (e) {
    $('.cookie-policy-container').removeClass('showing')
    document.cookie = 'kong-cookies=cookie-policy; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/'
  })

})(jQuery);

// Grab location data from Clearbit on input focus and append to city, state and country fields where possible
var locationData=0;$("input").focus(function(){if(locationData<1){locationData++;$.getScript("https://reveal.clearbit.com/v1/companies/reveal?authorization=pk_1bdbdbad26342e32516473510e95c3ff&variable=myVariable").done(function(e){$.ajax({url:"https://reveal.clearbit.com/v1/companies/reveal?authorization=pk_1bdbdbad26342e32516473510e95c3ff",dataType:"JSON"}).done(function(e){$('input[type=hidden][name="city"]').val(e.geoIP.city),$('input[type=hidden][name="state"]').val(e.geoIP.state),$('input[type=hidden][name="country"]').val(e.geoIP.country)}).fail(function(e){console.log("Clearbit Fail")})})}})

// Serialize form data on submission and include in Segment identify call, track submissions under "Signed Up" event

let anonID;
let userEmail;

  analytics.ready(function(){
      anonID = analytics.user().anonymousId();
      let serializeForm = function (form) {
      let obj = {};
      let formData = new FormData(form);
      let prop = ['email', 'first_name', 'last_name', 'Company', 'job_title', 'phone', 'state', 'city', 'country', 'gclid', 'utm_source', 'utm_medium', 'utm_ad_group', 'utm_content', 'utm_campaign'];
      for (let key of formData.keys()) {
        obj[key] = formData.get(key);
        if (obj[key] === null || obj[key] === "" || prop.indexOf(key) < 0) {
          delete obj[key];
        }
      }
      userEmail = obj.email;
      return obj;
    };

    document.addEventListener('submit', function (event) {
      let formData = serializeForm(event.target);
      analytics.alias(anonID, {integrations: {Mixpanel:"true"}});
      analytics.identify(anonID, formData);
      analytics.track("Signed Up");
    });
  });

  // Grab URL parameters for existing or returning visitors

  const formParams = new URLSearchParams(window.location.search);
  const visitorParam = formParams.get('v');
  const body = document.body;
  const navBar = document.getElementById('kong-main-nav');
  const visitorVar = localStorage.getItem("visitor");
  console.log(visitorVar);
  if ((visitorParam == "c") || (visitorVar == "login") && (visitorParam !== "p")){
    navBar.classList.add('login');
    body.classList.add('login');
    localStorage.setItem("visitor", 'login');
  }
  else if ((visitorParam == "p") || (visitorVar == "contactsales") && (visitorParam !== "c")){
    navBar.classList.add('contactsales');
    navBar.classList.remove('login');
    body.classList.remove('login');
    localStorage.setItem("visitor", 'contactsales');
  }
  else{
    navBar.classList.add('contactsales');
    navBar.classList.remove('login');
    body.classList.remove('login');
    localStorage.setItem("visitor", 'contactsales');
  }
  document.addEventListener("DOMContentLoaded", function() {
    navBar.classList.add('loaded');
  });
  wpcf7.cached = 0;
  $(window).load(function(){
    setTimeout(function(){
      localStorage.setItem("referral", window.location.href);
      localStorage.setItem("conversionURL", window.location.href);
    }, 1000);
  })
  jQuery('.cta-button').click(function(){
    localStorage.setItem("referral", window.location.href);
  })
  jQuery('.get-started-enterprise').click(function(){
    localStorage.setItem("referral", "enterprise-referral");
  });
  jQuery('.get-started-solutions').click(function(){
    localStorage.setItem("referral", "solutions-referral");
  });